<template>
  <div>
    <FITModal :title="$t('osm.serviceRequest.confirm.header')" ref="confirmation" reference="confirmation" @click="onConfirmation">
      <div slot="body">
        {{ $t(`osm.serviceRequest.confirm.body.${confirmationType}`) }}
      </div>
    </FITModal>
    <b-row align-h="center">
      <div class="w-75">
        <FITFormCard class="px-0 mx-0">
          <div slot="header">
            <span class="h5">{{  $t('osm.serviceRequest.policyInformation') }}</span>
          </div>
          <div slot="formBody">
            <b-row>
              <b-col cols="6">
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.policyNumber')" :value="policyDetail.policyNumber"></ServiceRequestDetailRow>
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.policyReference')" :value="policyDetail.policyReference"></ServiceRequestDetailRow>
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.policyStatus')" :value="policyDetail.policyStatus"></ServiceRequestDetailRow>
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.currency')" :value="policyDetail.policyCurrency"></ServiceRequestDetailRow>
              </b-col>
              <b-col cols="6">
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.modalPremium')" :value="policyDetail.modalPremium"></ServiceRequestDetailRow>
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.paymentMethod')" :value="policyDetail.paymentMethod"></ServiceRequestDetailRow>
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.premiumType')" :value="policyDetail.premiumType"></ServiceRequestDetailRow>
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.lastUpdateTime')" :value="policyDetail.lastUpdateTime"></ServiceRequestDetailRow>
              </b-col>
            </b-row>
            <b-row v-if="policy.policyType === 'P'">
              <b-col cols="6">
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.totalWithdrawals')" :value="policyDetail.totalWithdrawals"></ServiceRequestDetailRow>
              </b-col>
              <b-col cols="6">
                <ServiceRequestDetailRow :field="$t('osm.serviceRequest.policy.currentLoanAmount')" :value="policyDetail.currentLoanAmount"></ServiceRequestDetailRow>
              </b-col>
            </b-row>
          </div>
        </FITFormCard>
        <FITFormCard class="px-0 mx-0">
          <div slot="header">
            <b-row align-v="center">
              <b-col cols="6">
                <span class="h5">{{ $t(`osm.serviceRequest.type.${serviceRequestType.toUpperCase()}.header`) }}</span>
              </b-col>
              <b-col cols="6" class="text-right">
                <span class="h5" v-if="status === 'PEN' || !status"><i class="fa lock-pointer" :class="{ 'fa-lock': isLocked, 'fa-unlock': !isLocked }" @click="onLockClicked"></i></span>
                <span class="p-2 rounded" v-else :class=" { 'bg-success': status === 'APP', 'bg-danger': status === 'REJ' } ">
            <i class="fa py-2" :class=" { 'fa-times-circle': status === 'REJ',  'fa-check-circle' : status === 'APP'}"></i>
          {{ getServiceRequestTranslated($i18n.locale, 'serviceRequestStatus', status) }}</span>
              </b-col>
            </b-row>
          </div>
          <div slot="formBody">
            <b-row>
              <b-col cols="8">
                <slot name="serviceRequestType" :isLocked="isLocked" :status="status"></slot>
              </b-col>
            </b-row>
            <!-- Footer -->
            <div v-if="!status || status === 'PEN'">
              <b-row class="text-right">
                <b-col cols="8">
                  <FITDatePicker field="receiveTime" :rule="{required:true}" v-model="form.receiveTime" :label="$t('osm.serviceRequest.receiveTime')" :width="columnWidth" :disabled="isLocked"></FITDatePicker>
                </b-col>
              </b-row>
              <b-row class="text-right">
                <b-col cols="8">
                  <FITTextarea v-model="form.comment" :label="$t('osm.serviceRequest.comment')" :width="columnWidth" :disabled="isLocked"></FITTextarea>
                </b-col>
              </b-row>
              <span class="d-block h5">{{$t('osm.serviceRequest.fileUpload')}}</span>
              <b-row class="text-right">
                <b-col cols="12">
                  <FITWorkflowFileUpload ref="fitFileUpload" :uploadedFiles="uploadedFiles" :disabled="isLocked"></FITWorkflowFileUpload>
                </b-col>
              </b-row>
              <div v-if="permissionLevel<3.5">
                <b-row align-v="center" class="mt-2" v-if="status === 'PEN'">
                  <b-col cols="8">
                    <span class="lead"><i class="fa fa-thumbs-up mr-2"></i>{{ $t('osm.serviceRequest.approval') }}</span>
                  </b-col>
                </b-row>
                <b-row class="text-left" v-if="status === 'PEN'">
                  <b-col cols="8">
                    <FITDatePicker vuexObject="claimComplete" :rule="{required:true}" @validation="setValidationResult('completeTime',$event)" v-model="form.completeTime" :label="$t('osm.serviceRequest.completeTime')" :width="columnWidth"></FITDatePicker>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div v-else>
              <b-row class="text-left">
                <b-col cols="8">
                  <ServiceRequestDetailRow :field="$t('osm.serviceRequest.receiveTime')" :value="form.receiveTime"></ServiceRequestDetailRow>
                  <ServiceRequestDetailRow :field="$t('osm.serviceRequest.creator')" :value="form.creatorName"></ServiceRequestDetailRow>
                  <ServiceRequestDetailRow :field="$t('osm.serviceRequest.comment')" :value="form.comment"></ServiceRequestDetailRow>
                  <ServiceRequestDetailRow v-for="(file,index) in uploadedFiles" :field="(index==0)?$t('osm.serviceRequest.fileUpload'):''" :value="file.fileName" :clickable="true" @click="fileDownload(file.ID)"></ServiceRequestDetailRow>
                  <ServiceRequestDetailRow :field="$t('osm.serviceRequest.completeTime')" :value="form.completeTime"></ServiceRequestDetailRow>
                </b-col>
              </b-row>
            </div>
          </div>
        </FITFormCard>
        <div>
          <!-- For Pending Service Request -->
          <b-row align-v="center" class="justify-content-end" v-if="status === 'PEN'">
            <b-col cols="1" class="text-right">
              <!--  v-if="permissionLevel<3.5" -->
              <FITButton v-if="permissionLevel<3.5" faIcon="fa-times-circle" :text="$t('osm.serviceRequest.reject')" variant="danger" @click="showConfirmation('reject')"></FITButton>
            </b-col>
            <b-col cols="1" class="text-right">
              <FITButton v-if="permissionLevel<3.5" faIcon="fa-check-circle" :text="$t('osm.serviceRequest.approve')" variant="success" @click="showConfirmation('approve')"></FITButton>
            </b-col>
            <b-col v-if="status === 'PEN'" cols="1" class="text-right ml-3">
              <FITButton faIcon="fa-save" :text="$t('general.save')" variant="primary" @click="validationCheck" :disabled="isLocked"></FITButton>
            </b-col>
          </b-row>
          <!-- On initial service request creation  -->
          <b-row v-if="status == null">
            <b-col cols="2" offset="10" class="text-right">
              <FITButton faIcon="fa-save" :text="(serviceRequestStatus === 'PEN') ? $('general.save') : $t('general.create')" variant="primary" @click="validationCheck" :disabled="isLocked"></FITButton>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import {
  FITSearchableTable,
  FITFormCard,
  FITTextInput,
  FITDatePicker,
  FITAutoSearch,
  FITButton,
  FITSelect,
  FITTextarea,
  FITModal,
  FITValidationBus,
  FITWorkflowFileUpload
} from '@/components'

import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { API, APIList } from '@/api'
import moment from 'moment'
import ServiceRequestDetailRow from './ServiceRequestDetailRow'

export default {
  name: 'ServiceRequestCreate',
  components: {
    FITSearchableTable,
    FITFormCard,
    FITTextInput,
    FITAutoSearch,
    FITDatePicker,
    FITButton,
    FITSelect,
    FITTextarea,
    FITModal,
    ServiceRequestDetailRow,
    FITWorkflowFileUpload
  },

  props: {
    // Service Request ID
    initialID: {
      type: Number,
      default: null
    },

    policy: {
      type: Object,
      required: true
    },

    serviceRequestType: {
      type: String,
      required: true
    },

    shouldGetFields: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      policyDetail: {},
      confirmationType: 'approve',
      ID: this.initialID,
      status: null,
      columnWidth: 10,
      isLocked: false,
      linkedEntity: this.policy.policyType,
      linkedEntityID: this.policy.policyID,
      completeTime: '',
      form: {
        comment: '',
        receiveTime: moment().format('YYYY-MM-DD'),
        files: {},
        attachment: {},
      },
      validation: {
        completeTime: false
      },
      uploadedFiles: [],
      newFileUploaded: {},
      api: new APIList(),
    }
  },

  methods: {
    fileDownload(ID) {
      this.api.fileDownload(ID);
    },
    updateUploadedFiles(attachments) {
      this.uploadedFiles = [];
      for (var i = 0; i < attachments.length; i++) {
        let obj = {
          ID: '',
          fileName: '',
          size: '',
          publicDocument: '',
          documentTag: '',
          remarks: ''
        };
        obj.ID = attachments[i].ID;
        obj.fileName = attachments[i].documentName;
        obj.size = attachments[i].fileSize;
        obj.publicDocument = attachments[i].publicDocument;
        obj.documentTag = attachments[i].publicdocumentTagTag;
        obj.remarks = attachments[i].remarks;
        this.uploadedFiles.push(obj);
      }
    },
    initValidationStates() {
      FITValidationBus.$emit('reset', true);
      this.$store.commit('Validation/validationReset');
      this.$store.commit('Validation/setAlertMsg', { alertMsg: this.$t("validation.alertMsg.error") });
    },
    // uploadFile(){
    //   var fileData = this.$refs.fitFileUpload.formUploadFiles();
    //   // console.debug(fileData);
    //   Vue.set(this, 'newFileUploaded', fileData);
    //   return fileData;
    // },
    resetFileUpload() {
      var newData = this.newFileUploaded;
      if (!newData.files) {
        return;
      }
      this.$refs.fitFileUpload.removeAllFile();
      for (var i = 0; i < newData.files.length; i++) {
        var fileName = newData.files[i].name;
        var size = newData.files[i].size;
        var publicDocument = newData.attachment.publicDocument[i];
        var remarks = newData.attachment.remarks[i];
        var documentTag = newData.attachment.documentTag[i];
        this.uploadedFiles.push({ fileName, size, publicDocument, remarks, documentTag })
      }
      Vue.set(this, 'newFileUploaded', {});
      this.$refs.fitFileUpload.unlockFiles();
      Vue.set(this, 'isLocked', true);
    },
    onUploadedFile(files) {
      Vue.set(this, 'newFileUploaded', files);
      Vue.set(this.form, 'attachment', files.attachment);
      Vue.set(this.form, 'files', files.files);
    },
    validationCheck() {
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      return;
    },
    setValidationResult(key, value) {
      this.validation[key] = value;
    },
    checkValidationResult() {
      let results = this.validation;
      let finalResult = true;
      for (var key in results) {
        finalResult = finalResult && results[key];
      }
      return finalResult;
    },
    showConfirmation(type) {
      Vue.set(this, 'confirmationType', type);
      FITValidationBus.$emit('dirty', 'claimComplete');
      if (this.checkValidationResult()) {
        this.$refs.confirmation.openModal();
      }
    },
    onConfirmation(confirmed) {
      if (!confirmed) {
        return
      }
      switch (this.confirmationType) {
        case 'approve':
          this.approve();
          break
        case 'reject':
          this.reject();
          break
      }
      FITValidationBus.$emit('reset', true);
    },
    getOptionForKey(key, value) {
      this.$store.dispatch('searchOption', {
          dest: 'option',
          searchInput: {
            ID: key
          }
        })
        .then((json) => {

        })
    },

    isAutoFieldType(fieldType) {
      return !(fieldType === 'text' || fieldType === 'number' || fieldType === 'select' || fieldType === 'datetime');
    },

    onAutoSearchValueChanged(key, val) {
      Vue.set(this.form, key, val);
    },

    onLockClicked() {
      Vue.set(this, 'isLocked', !this.isLocked);
      this.$emit('onLockedChanged', this.isLocked);
    },

    isTextType(type) {
      return type === 'text' || type === 'number';
    },

    mapLabel(columnName) {
      return this.$t(`osm.serviceRequest.type.${this.selectedServiceType}.${columnName}`);
    },

    relativeArrowClass(isModified) {
      return isModified ? ['fa-arrow-circle-right', 'text-danger'] : ['fa-arrow-circle-left', 'text-success']
    },

    reset(column) {
      Vue.set(this.form, column, this.selectedType.data[column]);
    },

    resetAll() {
      Object.keys(this.form)
        .forEach((key) => {
          Vue.set(this.form, key, this.selectedType.data[key]);
        });
    },
    reject() {
      this.$store.dispatch('ServiceRequest/rejectServiceRequest', {
        ID: this.ID
      }).then((json) => {
        this.$store.commit({ type: 'ServiceRequest/setServiceRequestStatus', serviceRequestStatus: 'REJ' })
      }).catch((err) => {
        console.error(err);
      })
    },
    setLocked(isLocked = true) {
      Vue.set(this, 'isLocked', true);
    },
    approve() {
      this.$store.dispatch('ServiceRequest/approveServiceRequest', {
        ID: this.ID,
        completeTime: this.form.completeTime
      }).then((json) => {
        this.$store.commit({ type: 'ServiceRequest/setServiceRequestStatus', serviceRequestStatus: 'APP' })
      }).catch((err) => {
        console.error(err);
      })
    },
    submit() {
      let action = (!this.ID) ? 'createServiceRequest' : 'editServiceRequest';
      let params = {};
      var uploadedfileData = this.$refs.fitFileUpload.formUploadFiles();
      this.onUploadedFile(uploadedfileData);
      console.log(this.form);

      Object.keys(this.form)
        .forEach((key) => {
          if (this.form[key]) {
            params[key] = this.form[key];
          }
        });
      params['parameter'] = this.typeForm
      params['linkedEntity'] = this.linkedEntity
      params['linkedEntityID'] = this.linkedEntityID
      params['serviceType'] = this.serviceRequestType

      this.$store.dispatch(`ServiceRequest/${action}`, params)
        .then((json) => {
          Vue.set(this, 'isLocked', true)
          Vue.set(this, 'ID', parseInt(json.ID))
          this.resetFileUpload();
        })
        .catch((err) => {
          console.error(err);
        })
    }
  },
  computed: {
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
    ...mapGetters('ServiceRequest', [
      'getTranslated',
      'getTranslatedArray',
      'getTranslatedString',
      'isValueModified',
      'getServiceRequestTranslated'
    ]),
    ...mapState({
      'vuexFinalResult': state => state.Validation.validationFinalResult,
    }),
    ...mapState('ServiceRequest', [
      'fields',
      'selectedType',
      'typeForm',
      'generalForm',
      // 'serviceRequestType',
      'serviceRequestStatus'
    ]),

    serviceType() {
      let selections = this.getTranslated(this.$i18n.locale, 'serviceType');
      return selections;
    },
  },

  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form);
      }
    },

    generalForm: {
      deep: true,
      handler(val) {
        Vue.set(this, 'form', JSON.parse(
          JSON.stringify(val)
        ));
      }
    },

    serviceRequestStatus(val) {
      Vue.set(this, 'status', val);
    },
    vuexFinalResult(newData, oldData) {
      let result = newData;
      console.log("Final Result: " + newData);
      if (result) {
        this.submit();
        this.$store.commit('Validation/validationReset');
        FITValidationBus.$emit('reset', true);
      }
    }
  },

  created() {
    this.$store
      .dispatch('getAllSelections', 'sr')
      .then((json) => {
        this.$store.commit({ type: 'ServiceRequest/setSelections', selections: json.data });
      })
      .catch((err) => {
        console.error(err);
      })

    if (!this.shouldGetFields) {
      return
    }

    this.$store.dispatch('ServiceRequest/getFields', {
        type: this.serviceRequestType,
        ...this.policy
      })
      .then((json) => {

        if (!this.ID) {
          // Emit current data, assuming new service request
          this.$emit('onDataRetrived', json.data)
          return
        }

        this.$store
          .dispatch('ServiceRequest/getServiceRequestDetail', {
            ID: this.ID
          })
          .then((json) => {
            // console.log(json);
            Vue.set(this, 'isLocked', true);
            this.$emit('onLockedChanged', true);
            // Service Request ID is provided, retrieve and emit parameter from service request.
            // Parameters should be string originally
            this.$emit('onDataRetrived', JSON.parse(json.data.parameter))
            //       uploadedFileFields:['fileName','size','publicDocument','documentTag','remarks'],
            this.updateUploadedFiles(json.data.attachments);

          })
          .catch((err) => {
            console.error(err);
          })
      })
      .catch((err) => {

      })
    this.initValidationStates();
  },

  mounted() {
    this.$store.dispatch(
      'ServiceRequest/getServiceRequestPolicyDetail', this.policy
    ).then((result) => {
      Vue.set(this, 'policyDetail', result.data);
    }).catch((err) => {
      console.error(err);
    })
  },

  destroyed() {
    // this.$store.commit({ type: 'ServiceRequest/reset' })
    // Vue.set(this, 'form', {})
  }
}

</script>
<style>
.lock-pointer {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/components/ServiceRequestCreate.vue